export default __webpack_public_path__ + "static/Anthony-605bde26c4de7b15102dee5e51251a3b.jpg";